const initialState = {
    audioFileName : null, 
    audioId : null, 
    thumbnailId : null,
    transcription : null,
    type: null,
    audioBlob: null,
    audioDetails: null
};

const uploadAud= (state = initialState, action) =>{
    switch(action.type){
        case "UPLOAD_AUDIO" : 
        return {
            ...state,
            ...{
                audioFileName : action.payload.audioFileName, 
                audioId : action.payload.audioId, 
                thumbnailId : action.payload.thumbnailId,
                transcription : action.payload.transcription,
                type : action.payload.type,
                audioBlob : action.payload.audioBlob,
                audioDetails : action.payload.audioDetails,

                
            },

        };

        case "RESET_UPLOAD_AUDIO" :
            return {
                ...state,
                ...{
                    audioFileName : null, 
                    audioId : null, 
                    thumbnailId : null,
                    transcription : null,
                    type : null,
                    audioBlob: null
            }
        }
        
        default: return state;

    }
}



export default uploadAud;